export default __webpack_public_path__ + "08b228664ecabddb2b575dd45bde1899.png";